import { Tarjeta } from 'core/tarjeta/models/Tarjeta';

export class Cuenta {
  id: number;
  denominacion: string;
  numeroCuenta: number;
  saldoDisponible: number;
  saldoAutorizaciones: number;
  codigoEmpresa: string;
  codigoBanco: string;
  nombreCentroCosto: string;
  tipoCuenta: 'CENTRO_COSTO' | 'TARJETA';
  tarjetas: Tarjeta[];
  label: string;

  constructor(cuenta: Partial<Cuenta>) {
    this.id = cuenta.id;
    this.denominacion = cuenta.denominacion;
    this.numeroCuenta = cuenta.numeroCuenta;
    this.saldoDisponible = cuenta.saldoDisponible;
    this.saldoAutorizaciones = cuenta.saldoAutorizaciones;
    this.codigoEmpresa = cuenta.codigoEmpresa;
    this.codigoBanco = cuenta.codigoBanco;
    this.nombreCentroCosto = cuenta.nombreCentroCosto;
    this.tipoCuenta = cuenta.tipoCuenta;
    this.tarjetas = (cuenta.tarjetas || []).map((t) => new Tarjeta(t));
    this.label = this.formatLabel(cuenta);
  }

  formatLabel(cuenta: Partial<Cuenta>): string {
    if (!cuenta?.numeroCuenta) {
      return '';
    }

    const numeroBase = cuenta.denominacion
      ? `${cuenta.numeroCuenta} - ${cuenta.denominacion}`
      : `${cuenta.numeroCuenta}`;

    if (cuenta.tipoCuenta === 'CENTRO_COSTO') {
      return cuenta.nombreCentroCosto
        ? `${numeroBase} / ${cuenta.nombreCentroCosto}`
        : numeroBase;
    }

    if (cuenta.tipoCuenta === 'TARJETA') {
      const tarjetasLabel = (cuenta.tarjetas || [])
        .reduce((str, t) => str + t.denominacion + ' - ', ' ')
        .slice(0, -3)
        .trim();
      return tarjetasLabel ? `${numeroBase} / ${tarjetasLabel}` : numeroBase;
    }

    return numeroBase;
  }

  get numerosTarjeta(): string {
    return this.tarjetas.reduce((str, t) => str + t.numero + '-', '');
  }
}
